import React from "react"

const SidebarGroupHeader = ({ header }) => (
  <h2 className="text-xs font-bold leading-tight tracking-tight pl-4 pr-4 py-1 mt-4 uppercase text-gray-500">
    {header}
  </h2>
)

export default SidebarGroupHeader
